import React from "react";

interface ConferenceFormActionsProps {
  onSave: () => void;
  onCancel: () => void;
}

const ConferenceFormActions: React.FC<ConferenceFormActionsProps> = ({
  onSave,
  onCancel,
}) => {
  return (
    <div className="flex justify-end gap-2">
      <button
        type="button"
        onClick={onCancel}
        className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium hover:bg-gray-400 transition-colors flex items-center space-x-2"
      >
        <span>Hủy</span>
      </button>
      <button
        type="button"
        onClick={onSave}
        className="bg-green-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors flex items-center space-x-2"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
          />
        </svg>
        <span>Lưu dữ liệu</span>
      </button>
    </div>
  );
};

export default ConferenceFormActions;
